<template>
  <component 
    v-if="hasValidTypeAndContent" 
    :is="type"
    :content="content.content" />
</template>

<script>

import Afbeelding from '@/components/content/Afbeelding';
import Paragraph from '@/components/content/Paragraph';
import Video from '@/components/content/Video';
import Quote from '@/components/content/Quote';

export default {
  name: 'TimeLineSegmentContent',
  components: {
    Afbeelding,
    Paragraph,
    Video,
    Quote
  },
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasValidTypeAndContent() {
      return this.type !== false && this.content.content;
    },
    type() {
      switch(this.content.type) {
        case 'text' :
          return 'Paragraph';
        case 'video':
          return 'Video';
        case 'afbeelding':
          return 'Afbeelding';
        case 'quote':
          return 'Quote';
      }
      return false;
    }
  }
}
</script>
